import cssUtil from 'gw-portals-util-js/CssUtil';
import template from 'text!./cp-premises-summary-directive.html';
import styles from './PremisesSummary-hashed.scss';

export default [function () {
    return {
        restrict: 'E',
        replace: true,
        scope: {
            type: '@',
            heading: '@',
            subHeading: '=',
            isOpen: '='
        },
        transclude: true,
        template: cssUtil.hashTemplate(template, styles),
        controller: ['$scope', function ($scope) {

            $scope.accordianProps = { isOpen: true };
            $scope.$watch('type', function (value) {
                switch (value) {
                    case 'location':
                        $scope.icon = 'gw-icon fa fa-map-marker';
                        break;
                    case 'building':
                        $scope.icon = 'gw-icon fa fa-building-o';
                        break;
                    case 'coverages':
                        $scope.icon = 'gw-icon fa fa-umbrella';
                        break;
                    default:
                        $scope.icon = 'gw-icon fa fa-check';
                        break;
                }
            });

            $scope.$watch('isOpen', function (value) {
                $scope.accordianProps.isOpen = value;
            });
        }]
    };
}];


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gw-portals-cp-components-angular/buildingsWizard/directives/cp-premises-summary-directive/CPPremisesSummaryDirective.js
// module id = 996
// module chunks = 0